import axios from "axios";
import React, { memo, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { openModal } from "../redux/modalSlice";
import { subscription } from "../redux/userSlice";
import { Bookmark, BookmarkX, Pencil } from "lucide-react";
import UserAvatar from "./UserAvatar";
import Button from "../components/atoms/Button";
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ChannelInfo = styled.span`
  display: flex;
  gap: 20px;
`;
const ChannelDetails = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colorOnBackground};
`;
const ChannelName = styled.span``;
const ChannelCounter = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
  margin-top: 4px;
`;
const ChannelDescription = styled.p`
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 12px;
`;
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  color: ${({ theme }) => theme.colorOnBackground};
`;
const RecipeChannelBar = memo(function ({ currentVideo }) {
  const path = useLocation().pathname.split("/")[2];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [channel, setChannel] = useState([]);
  const [bookmarks, setBookmarks] = useState([]);
  //USEEFFECTS
  const loadRecipeChannel = useCallback(async () => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/users/find/${currentVideo?.userId}`,
          { withCredentials: true },
        )
        .then((channelRes) => {
          if (channelRes.status === 200) {
            setChannel(channelRes.data);
          }
        });
    } catch (err) {
      console.log("Error fetching channel: ", err);
    }
  }, [currentVideo]);
  useEffect(() => {
    loadRecipeChannel();
  }, [path, loadRecipeChannel]);
  //HANDLES
  const handleSub = async () => {
    currentUser?.subscribedUsers.includes(channel._id)
      ? await axios.delete(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/users/sub/${channel._id}`,
          null,
          {
            withCredentials: true,
          },
        )
      : await axios.post(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/users/sub/${channel._id}`,
          { withCredentials: true },
        );
    dispatch(subscription(channel._id));
  };
  const handleBookmark = async () => {
    handleOpenAddToCollectionModal();
    const videoId = currentVideo._id;
    console.log(document.cookie);
    if (bookmarks.length > 0) {
      await axios.delete(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/bookmarks/delete/${bookmarks[0]._id}`,
        {
          withCredentials: true,
        },
      );
      const fetchBookmarks = async () => {
        if (currentVideo) {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_RECIPE_API_BASE_URL}/bookmarks/${currentVideo._id}`,
              { withCredentials: true },
            );
            setBookmarks(res.data);
          } catch (err) {}
        }
      };
      fetchBookmarks();
    } else {
      await axios.post(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/bookmarks`,
        { videoId },
        {
          withCredentials: true,
        },
      );
      const fetchBookmarks = async () => {
        if (currentVideo) {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_RECIPE_API_BASE_URL}/bookmarks/${currentVideo._id}`,
              { withCredentials: true },
            );
            setBookmarks(res.data);
          } catch (err) {}
        }
      };
      fetchBookmarks();
    }
  };
  const handleOpenAddToCollectionModal = () => {
    dispatch(openModal("AddToCollection"));
  };
  const handleSignUp = (e) => {
    navigate("/signin");
  };
  return (
    <Container>
      <ChannelInfo>
        <Link
          to={`/profile/${channel._id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <UserAvatar
            src={channel.img}
            name={channel.name}
            contrastColor={channel.contrastColor}
            size={50}
          />
        </Link>
        <ChannelDetails>
          <Link
            to={`/profile/${channel._id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ChannelName>{channel?.name}</ChannelName>
          </Link>
          <ChannelCounter>{channel?.subscribers} Subscribers</ChannelCounter>
          <ChannelDescription>{channel?.desc}</ChannelDescription>
        </ChannelDetails>
      </ChannelInfo>
      <Buttons>
        {currentUser ? (
          currentUser?._id === channel._id ? (
            <Link
              to={`/edit/${currentVideo?._id || "Loading..."}`}
              style={{ textDecoration: "none" }}
            >
              <Button size="md" icon={<Pencil />} label="Edit" />
            </Link>
          ) : (
            <Button
              size="md"
              color={
                currentUser.subscribedUsers?.includes(channel._id)
                  ? "black"
                  : "red"
              }
              label={
                currentUser.subscribedUsers?.includes(channel._id)
                  ? "Subscribed"
                  : "Subscribe"
              }
              onClick={handleSub}
            />
          )
        ) : (
          <Link
            to={`/signin`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Button
              size="md"
              color="red"
              label="Subscribe"
              onClick={handleSignUp}
            />
          </Link>
        )}
        {currentUser === null ? (
          <Button
            variant="filled"
            size="md"
            icon={<Bookmark />}
            onClick={handleSignUp}
          />
        ) : (
          <Button
            variant="filled"
            size="md"
            icon={bookmarks.length > 0 ? <BookmarkX /> : <Bookmark />}
            onClick={handleBookmark}
          />
        )}
      </Buttons>
    </Container>
  );
});
export default RecipeChannelBar;
